module.exports = "<div ng-datepicker ng-model=\"fakeVM.value\" min-view=\"day\"></div>"